import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild, ElementRef } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { BankInfo } from "src/app/models";
import { ApsService } from "src/app/services";
import { AddressComponent } from "../address";
import { CustomHttpInterceptor } from "src/app/http-interceptor";

@Component({
  selector: "app-new-bank",
  templateUrl: "./new-bank.component.html",
  styleUrls: ["./new-bank.component.scss"]
})
export class NewBankComponent implements OnInit, AfterViewInit
{
  @ViewChild(AddressComponent) addressElement: AddressComponent;
  public form: FormGroup;
  @Input() public showPrimary: boolean = true;
  @Input() public showAddress: boolean = true;
  nameOfBank: string;

  constructor(
    private formBuilder: FormBuilder,
    private changedetectorRef: ChangeDetectorRef,
    public apsService: ApsService,
    public httpInterceptor: CustomHttpInterceptor) { }


  public ngOnInit(): void
  {
    this.form = this.formBuilder.group({
      NameFirst: ["", [Validators.required]],
      NameLast: ["", [Validators.required]],
      CompanyName: [""],
      RoutingNumber: ["", [Validators.required, Validators.pattern(/^[0-9]{9}$/), this.routingNumberChecksumValidator()]],
      AccountNumber: ["", [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(5), Validators.maxLength(17)]],
      ConfirmAccountNumber: ["", [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(5), Validators.maxLength(17)]],
      AccountType: ["", [Validators.required]],
      BankName: [""],
      Business: [false],
      Primary: [false]
    });
    this.form.get('AccountNumber')!.valueChanges.subscribe(() => this.matchAccountNumber());
    this.form.get('ConfirmAccountNumber')!.valueChanges.subscribe(() => this.matchAccountNumber());
  }

  public ngAfterViewInit(): void
  {
    this.changedetectorRef.detectChanges();
    if (this.showAddress)
    {
      this.form.addControl("Address", this.addressElement.form);
      this.addressElement.form.setParent(this.form);
    }
  }



  onInput(value: string): void
  {
    if (!this.isNineDigitRoutingNumber(value))
    {
      this.nameOfBank = null;
      this.form.get("BankName")?.reset();
      return;
    }

    this.apsService.lookupBankName(value).subscribe(response =>
    {
      this.nameOfBank = response?.StringValue ?? null;
      this.form.get("BankName")?.patchValue(this.nameOfBank);

    });
  }


  public matchAccountNumber(): void
  {
    const accountValue = this.form.get('AccountNumber')!.value;
    const confirmAccountValue = this.form.get('ConfirmAccountNumber')!;

    if (accountValue === confirmAccountValue.value)
    {
      confirmAccountValue.setErrors(null);
    }
    else
    {
      confirmAccountValue.setErrors({ mismatch: true });
    }
  }


  private isNineDigitRoutingNumber(value: string): boolean
  {
    return value.length === 9 && [...value].every(char => char >= "0" && char <= "9");
  }


  private routingNumberChecksumValidator(): ValidatorFn
  {
    return (control: AbstractControl): ValidationErrors | null =>
    {
      const value = String(control.value ?? "");

      if (!this.isNineDigitRoutingNumber(value))
      {
        return null;
      }

      const digits = [...value].map(Number);
      const sum = 3 * (digits[0] + digits[3] + digits[6]) + 7 * (digits[1] + digits[4] + digits[7]) + digits[2] + digits[5] + digits[8];

      return sum % 10 === 0 ? null : { routingChecksum: true };
    };
  }

  
  public getBankInfo(): BankInfo
  {
    let result: BankInfo = null;
    if (this.form.dirty) 
    {
      const { Address, ConfirmAccountNumber, ...values } = this.form.value; 
      result = { ...values, ...this.form.value.Address, ...this.form.value.ConfirmAccountNumber };
    }
    return result;
  }
}
